import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { authPath, stashReturnTo } from "@/lib/guestGate";

// Read-only visitor card: replaces the comment box (light) or sits above the reaction row of the
// mobile viewers (compact + dark). Both buttons keep the current URL so the visitor comes back here.
export const GuestCta = ({ dark = false, compact = false, safeBottom = false, testId = "guest-cta", className = "" }) => {
  const { t } = useApp();
  const nav = useNavigate();
  const go = (tab) => { stashReturnTo(); nav(authPath(tab)); };
  const title = t("guest.cta_title", "Rejoins Yalola pour réagir et commenter");

  if (compact) {
    return (
      <div
        className={`flex items-center gap-3 rounded-xl px-3 py-2 ${dark ? "bg-white/10" : ""} ${className}`}
        style={dark ? undefined : { background: "var(--yalola-surface-alt)" }}
        data-testid={testId}
      >
        <Lock size={16} className="shrink-0" style={{ color: dark ? "#fff" : "var(--yalola-primary)" }} />
        <div className="flex-1 min-w-0 text-[13px] font-semibold leading-snug" data-testid={`${testId}-title`}>{title}</div>
        <Button size="sm" className="rounded-full pill-primary shrink-0 h-8 px-3" onClick={() => go("login")} data-testid={`${testId}-login`}>
          {t("guest.login", "Se connecter")}
        </Button>
      </div>
    );
  }

  return (
    <div
      className={`border-t px-4 py-3 shrink-0 ${className}`}
      style={{ borderColor: "var(--yalola-border)", ...(safeBottom ? { paddingBottom: "calc(0.75rem + var(--sa-bottom, 0px))" } : null) }}
      data-testid={testId}
    >
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 rounded-full grid place-items-center shrink-0" style={{ background: "var(--yalola-primary-soft)" }}>
          <Lock size={16} style={{ color: "var(--yalola-primary)" }} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-bold font-display leading-snug" style={{ color: "var(--yalola-text)" }} data-testid={`${testId}-title`}>{title}</div>
          <div className="text-xs mt-0.5" style={{ color: "var(--yalola-text-muted)" }} data-testid={`${testId}-desc`}>
            {t("guest.cta_desc", "Tu consultes cette publication en tant que visiteur.")}
          </div>
        </div>
      </div>
      <div className="mt-3 flex gap-2">
        <Button className="flex-1 rounded-full pill-primary h-10" onClick={() => go("login")} data-testid={`${testId}-login`}>{t("guest.login", "Se connecter")}</Button>
        <Button variant="outline" className="flex-1 rounded-full h-10" onClick={() => go("register")} data-testid={`${testId}-register`}>{t("guest.register", "Créer un compte")}</Button>
      </div>
    </div>
  );
};

export default GuestCta;
